import { z } from 'zod';

export type MonthDeclarationDto = z.infer<typeof monthDeclarationDtoSchema>;

export const monthDeclarationDtoSchema = z.object({
  id: z.number(),
  seasonId: z.string(),
  month: z.number(),
  year: z.number(),
  co2: z.object({
    cateringMeal: z.array(
      z.object({
        sector: z.string(),
        mealType: z.string(),
        mealCount: z.number(),
      }),
    ),
    cateringBeverage: z.array(
      z.object({
        sector: z.string(),
        beverageType: z.string(),
        beverageCount: z.number(),
      }),
    ),
    energy: z.array(
      z.object({
        sector: z.string(),
        energyType: z.string(),
        energyConsumptionQuantity: z.number(),
      }),
    ),
    water: z.object({
      sector: z.string(),
      waterConsumptionVolume: z.number(),
    }),
    wasteRecyclable: z.array(
      z.object({
        sector: z.string(),
        recyclableWasteType: z.string(),
        recyclableWasteQuantity: z.number(),
      }),
    ),
    wasteNonRecyclable: z.array(
      z.object({
        sector: z.string(),
        nonRecyclableWasteType: z.string(),
        nonRecyclableWasteQuantity: z.number(),
      }),
    ),
    digital: z.object({
      sector: z.string(),
      dataUsage: z.number(),
      videoViews: z.number(),
    }),
  }),
});

export const getMonthDeclarationsDtoSchema = z.object({
  data: z.array(monthDeclarationDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});
